import ReactGA from 'react-ga4';

// Your Google Analytics measurement ID
const TRACKING_ID = 'G-WZMXSMQB84';

// Initialize Google Analytics
export const initGA = () => {
  ReactGA.initialize(TRACKING_ID);
};

// Track page views
export const logPageView = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

// Track events
export const logEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

// Track user exceptions/errors
export const logException = (description: string, fatal = false) => {
  ReactGA.event({
    category: 'Exception',
    action: description,
    label: fatal ? 'fatal' : 'non-fatal'
  });
};

// Track user timing for performance metrics
export const logTiming = (category: string, variable: string, value: number, label?: string) => {
  ReactGA.event({
    category: 'Timing',
    action: variable,
    value,
    label: label || category
  });
};

// Track user identification when they log in
export const setUser = (userId: string) => {
  ReactGA.set({ userId });
}; 